<template>
  <div>
    <b-overlay
      id="overlay-background"
      :show="loader === true"
      variant="dark"
      opacity="0.85"
      blur="2px"
      rounded="sm"
      spinner-variant="primary"
      spinner-medium
    >
      <b-card>
        <b-alert
          v-if="emptyvalues > 0"
          variant="warning"
          show
        >
          <div class="alert-body">
            {{ $t('DEBTIA_FILL_EMPTY_VALUES_MESSAGE') }}
          </div>
        </b-alert>
        <div class="m-2">
          <b-row
            class="process-row"
          >
            <b-col
              cols="12"
              md="6"
              class="process-title"
            >
              <div class="d-flex align-items-center">
                <b-input-group prepend="Title">
                  <b-form-input
                    id="h-password"
                    v-model="processtitle"
                    type="text"
                    placeholder="Process Title"
                    @keyup="checktitle"
                  />
                </b-input-group>
              </div>
              <small
                v-if="processTitleError"
                class="title-error-class"
              >*Title of the process is required.</small>
            </b-col>
            <b-col
              cols="12"
              md="6"
            >
              <div class="d-flex align-items-center justify-content-end">
                <b-button
                  id="add-module-btn"
                  variant="primary"
                  :disabled="haltBtn"
                  @click="saveProcess"
                >
                  <span class="text-nowrap">Save Copy</span>
                </b-button>
              </div>
            </b-col>
          </b-row>
          <b-row
            v-if="APIprocessmodules.length > 0"
          >
            <template
              v-for="processmodule in APIprocessmodules"
            >
              <b-col
                v-if="processmodule.module_id === 1 && processmodule.depends_on === 0"
                :key="processmodule.id"
                cols="12"
                md="12"
                class="main-cols"
              >
                <b-alert
                  variant="primary"
                  show
                >
                  <h4 class="alert-heading">
                    {{ processmodule.module_title }}
                  </h4>
                  <div class="alert-body">
                    <await-module-copy
                      :process-module="processmodule"
                    />
                  </div>
                </b-alert>
              </b-col>
              <b-col
                v-if="((processmodule.module_id === 2 || processmodule.module_id === 9 || processmodule.module_id === 14) && processmodule.depends_on === 0) && (contactOptionsCheck && letterTemplatesCheck && emailTemplatesCheck)"
                :key="processmodule.id"
                cols="12"
                md="12"
                class="main-cols"
              >
                <b-alert
                  variant="primary"
                  show
                >
                  <condition-details
                    :ref="'processmodule-'+processmodule.id"
                    :module-settings="processmodule"
                    :parent-module="processmodule.id"
                    :condition-check="conditionCheck"
                    :state="0"
                    :contact-options="contactOptions"
                    :api-process-modules="APIprocessmodules"
                    @addChildModule="addConditionModule($event)"
                  />
                </b-alert>
              </b-col>
              <b-col
                v-if="processmodule.module_id === 3 && processmodule.depends_on === 0 && (!contactOptionsCheck && !emailTemplatesCheck && !letterTemplatesCheck)"
                :key="processmodule.id"
                cols="12"
                md="12"
                class="main-cols"
              >
                Data is loading.
              </b-col>
              <b-col
                v-if="processmodule.module_id === 3 && processmodule.depends_on === 0 && (contactOptionsCheck && letterTemplatesCheck)"
                :key="processmodule.id"
                cols="12"
                md="12"
                class="main-cols"
              >
                <send-letter-or-email
                  :id="`section-${processmodule.id}`"
                  :ref="`section-${processmodule.id}`"
                  :current-module="3"
                  form-group-label="DEBTIA_LETTER_TEMPLATE_TEXT"
                  :process-module="processmodule"
                  :letter-templates="letterTemplates"
                  :file-categories="fileCategories"
                  :special-options="specialOptions"
                  :template-variable-options="templateVariableOptions"
                  :contact-options="contactOptions"
                  :client-id="letter_client_id"
                  :secret="letter_secret"
                  :email-templates="emailTemplates"
                  :prev-module-options="prevModuleOptions"
                  :payment-email-template="paymentEmailTemplate"
                />
              </b-col>
              <b-col
                v-if="processmodule.module_id === 4 && processmodule.depends_on === 0 && (contactOptionsCheck && emailTemplatesCheck)"
                :key="processmodule.id"
                cols="12"
                md="12"
                class="main-cols"
              >
                <send-letter-or-email
                  :id="`section-${processmodule.id}`"
                  :ref="`section-${processmodule.id}`"
                  :current-module="4"
                  form-group-label="DEBTIA_EMAIL_TEMPLATE_TEXT"
                  :process-module="processmodule"
                  :letter-templates="letterTemplates"
                  :file-categories="fileCategories"
                  :special-options="specialOptions"
                  :template-variable-options="templateVariableOptions"
                  :client-id="email_client_id"
                  :secret="email_secret"
                  :email-templates="emailTemplates"
                  :prev-module-options="prevModuleOptions"
                  :payment-email-template="paymentEmailTemplate"
                />
              </b-col>
              <b-col
                v-if="(processmodule.module_id === 5 || processmodule.module_id === 6) && processmodule.depends_on === 0"
                :key="processmodule.id"
                cols="12"
                md="12"
                class="main-cols"
              >
                <b-alert
                  variant="primary"
                  show
                >
                  <h4 class="alert-heading">
                    {{ processmodule.module_title }}
                  </h4>
                  <div class="alert-body">
                    <b-list-group
                      flush
                      class="awaitlist"
                    >
                      <b-list-group-item
                        v-if="processmodule.module_id === 5"
                        class="main-items"
                      >
                        <b-form-group
                          label="Process"
                          class="awaitModuleFields"
                          label-for="awaitType"
                          label-cols-md="4"
                        >
                          <v-select
                            v-model="processmodule.module_settings.new_process_id"
                            :dir="$store.state.appConfig.isRTL ? 'rtl' : 'ltr'"
                            :options="processes"
                            :reduce="val => val.value"
                            :clearable="false"
                            input-id="activeProcesses"
                          />
                        </b-form-group>
                      </b-list-group-item>
                      <b-list-group-item
                        v-if="processmodule.module_id === 6"
                        class="main-items"
                      >
                        Action : {{ processmodule.module_id === 5 ? getState(processmodule.module_settings.new_process_id) : processmodule.module_settings.reason }}
                      </b-list-group-item>
                    </b-list-group>
                  </div>
                </b-alert>
              </b-col>
              <b-col
                v-if="processmodule.module_id === 7 && processmodule.depends_on === 0"
                :key="processmodule.id"
                cols="12"
                md="12"
                class="main-cols"
              >
                <b-alert
                  variant="primary"
                  show
                >
                  <h4 class="alert-heading">
                    {{ processmodule.module_title }}
                  </h4>
                  <div class="alert-body">
                    <b-list-group
                      flush
                      class="awaitlist"
                    >
                      <b-list-group-item
                        class="main-items"
                      >
                        {{ $t('DEBTIA_FEE') }} : {{ processmodule.module_settings.reminder_fee }}
                      </b-list-group-item>
                    </b-list-group>
                  </div>
                </b-alert>
              </b-col>
              <b-col
                v-if="processmodule.module_id === 8 && processmodule.depends_on === 0"
                :key="processmodule.id"
                cols="12"
                md="12"
                class="main-cols"
              >
                <b-alert
                  variant="primary"
                  show
                >
                  <h4 class="alert-heading">
                    {{ processmodule.module_title }}
                  </h4>
                  <div class="alert-body">
                    <b-list-group
                      flush
                      class="awaitlist"
                    >
                      <b-list-group-item
                        class="list-variable-item"
                      >
                        <b-row>
                          <b-col
                            cols="12"
                            md="4"
                            class="group-col"
                          >
                            <b-form-group
                              label-for="recipient"
                              label-cols-md="12"
                              class="process-group"
                            >
                              <label>
                                {{ $t('DEBTIA_RECIPIENT') }} : {{ processmodule.module_settings.recipient }}
                              </label>
                            </b-form-group>
                          </b-col>
                          <b-col
                            cols="12"
                            md="4"
                            class="group-col"
                          >
                            <b-form-group
                              label-for="subtotal"
                              label-cols-md="12"
                              class="process-group"
                            >
                              <label>
                                {{ $t('DEBTIA_SUBTOTAL') }} : {{ processmodule.module_settings.subtotal }}
                              </label>
                            </b-form-group>
                          </b-col>
                          <b-col
                            cols="12"
                            md="4"
                            class="group-col"
                          >
                            <b-form-group
                              label-for="vat_amount"
                              label-cols-md="12"
                              class="process-group"
                            >
                              <label>
                                {{ $t('DEBTIA_VATAMOUNT') }} : {{ processmodule.module_settings.vat_amount }}
                              </label>
                            </b-form-group>
                          </b-col>
                          <b-col
                            cols="12"
                            md="4"
                            class="group-col"
                          >
                            <b-form-group
                              label-for="total"
                              label-cols-md="12"
                              class="process-group"
                            >
                              <label>
                                {{ $t('DEBTIA_TOTAL') }} : {{ processmodule.module_settings.total }}
                              </label>
                            </b-form-group>
                          </b-col>
                          <b-col
                            cols="12"
                            md="4"
                            class="group-col"
                          >
                            <b-form-group
                              label-for="await_payment"
                              label-cols-md="12"
                              class="process-group"
                            >
                              <label>
                                {{ $t('DEBTIA_AWAIT_PAYMENT') }} : {{ processmodule.module_settings.await_payment === 1 ? 'True' : 'False' }}
                              </label>
                            </b-form-group>
                          </b-col>
                        </b-row>
                      </b-list-group-item>
                      <b-list-group-item>
                        <b-list-group-item
                          class="main-items"
                        >
                          {{ $t('DEBTIA_INVOICE_PRODUCTS') }}
                        </b-list-group-item>
                        <b-list-group-item
                          class="list-variable-item"
                        >
                          <b-row>
                            <b-col

                              cols="12"
                              md="3"
                              class="group-col"
                            >
                              <b-form-group
                                label-cols-md="12"
                                class="process-group text-center"
                              >
                                <label>{{ $t('DEBTIA_PRODUCT_NAME') }}</label>
                              </b-form-group>
                            </b-col>

                            <b-col

                              cols="12"
                              md="3"
                              class="group-col"
                            >
                              <b-form-group
                                label-cols-md="12"
                                class="process-group text-center"
                              >
                                <label>{{ $t('DEBTIA_QUANTITY') }}</label>
                              </b-form-group>
                            </b-col>
                            <b-col

                              cols="12"
                              md="3"
                              class="group-col"
                            >
                              <b-form-group
                                label-cols-md="12"
                                class="process-group text-center"
                              >
                                <label>{{ $t('DEBTIA_UNIT_PRICE') }}</label>
                              </b-form-group>
                            </b-col>
                            <b-col

                              cols="12"
                              md="3"
                              class="group-col"
                            >
                              <b-form-group
                                label-cols-md="12"
                                class="process-group text-center"
                              >
                                <label>{{ $t('DEBTIA_TOTAL_PRICE') }}</label>
                              </b-form-group>
                            </b-col>
                          </b-row>

                        </b-list-group-item>
                        <b-list-group-item
                          v-for="(variable, i) in processmodule.module_settings.get_products"
                          :key="variable.id"
                          class="list-variable-item"
                        >
                          <b-row>
                            <b-col

                              cols="12"
                              md="3"
                              class="group-col"
                            >
                              <b-form-group
                                :label="variable.custom_variable"
                                label-cols-md="12"
                                class="process-group text-center"
                              >
                                <span>{{ i+1 }} - {{ variable.product_name }}</span>
                              </b-form-group>
                            </b-col>
                            <b-col

                              cols="12"
                              md="3"
                              class="group-col"
                            >
                              <b-form-group
                                :label="variable.custom_variable"
                                label-cols-md="12"
                                class="process-group text-center"
                              >
                                <span>{{ variable.quantity }}</span>
                              </b-form-group>
                            </b-col>
                            <b-col

                              cols="12"
                              md="3"
                              class="group-col"
                            >
                              <b-form-group
                                :label="variable.custom_variable"
                                label-cols-md="12"
                                class="process-group text-center"
                              >
                                <span>{{ variable.unit_price }}</span>
                              </b-form-group>
                            </b-col>
                            <b-col

                              cols="12"
                              md="3"
                              class="group-col"
                            >
                              <b-form-group
                                :label="variable.custom_variable"
                                label-cols-md="12"
                                class="process-group text-center"
                              >
                                <span>{{ variable.total_price }}</span>
                              </b-form-group>
                            </b-col>
                          </b-row>
                        </b-list-group-item>
                      </b-list-group-item>
                    </b-list-group>
                  </div>
                </b-alert>
              </b-col>
              <b-col
                v-if="processmodule.module_id === 10 && processmodule.depends_on === 0"
                :key="processmodule.id"
                cols="12"
                md="12"
                class="main-cols"
              >
                <b-alert
                  variant="primary"
                  show
                >
                  <h4 class="alert-heading">
                    {{ processmodule.module_title }}
                  </h4>
                  <div class="alert-body">
                    <b-list-group
                      flush
                      class="awaitlist"
                    >
                      <b-list-group-item
                        class="main-items"
                      >
                        {{ $t('DEBTIA_TASK_LIST') }} : {{ processmodule.module_settings.title }}
                      </b-list-group-item>
                    </b-list-group>
                  </div>
                </b-alert>
              </b-col>
              <b-col
                v-if="processmodule.module_id === 11 && processmodule.depends_on === 0"
                :key="processmodule.id"
                cols="12"
                md="12"
                class="main-cols"
              >
                <b-alert
                  variant="primary"
                  show
                >
                  <h4 class="alert-heading">
                    {{ processmodule.module_title }}
                  </h4>
                  <div class="alert-body">
                    <b-list-group
                      flush
                      class="awaitlist"
                    >
                      <b-list-group-item
                        class="main-items"
                      >
                        A Compensation Fee of 310 per Invoice Document will be charged.
                      </b-list-group-item>
                    </b-list-group>
                  </div>
                </b-alert>
              </b-col>
              <b-col
                v-if="processmodule.module_id === 12 && processmodule.depends_on === 0"
                :key="processmodule.id"
                cols="12"
                md="12"
                class="main-cols"
              >
                <b-alert
                  variant="primary"
                  show
                >
                  <h4 class="alert-heading">
                    {{ processmodule.module_title }}
                  </h4>
                  <div class="alert-body">
                    <b-list-group
                      flush
                      class="awaitlist"
                    >
                      <b-list-group-item
                        class="main-items"
                      >
                        Collection Cost will be auto calculated.
                      </b-list-group-item>
                    </b-list-group>
                  </div>
                </b-alert>
              </b-col>
              <b-col
                v-if="processmodule.module_id === 13 && processmodule.depends_on === 0"
                :key="processmodule.id"
                cols="12"
                md="12"
                class="main-cols"
              >
                <b-alert
                  variant="primary"
                  show
                >
                  <h4 class="alert-heading">
                    {{ processmodule.module_title }}
                  </h4>
                  <div class="alert-body">
                    <b-list-group
                      flush
                      class="awaitlist"
                    >
                      <b-list-group-item
                        class="main-items"
                      >
                        {{ $t('DEBTIA_COLLECTION_FEE') }} : {{ processmodule.module_settings.collection_fee }}
                      </b-list-group-item>
                    </b-list-group>
                  </div>
                </b-alert>
              </b-col>
              <b-col
                v-if="processmodule.module_id === 15 && processmodule.depends_on === 0"
                :key="processmodule.id"
                cols="12"
                md="12"
                class="main-cols"
              >
                <b-alert
                  variant="primary"
                  show
                >
                  <h4 class="alert-heading">
                    {{ processmodule.module_title }}
                  </h4>
                  <div class="alert-body">
                    <b-list-group
                      flush
                      class="awaitlist"
                    >
                      <b-list-group-item>
                        {{ $t('DEBTIA_CUSTOM_FIELD_DATA_MODULE') }}
                      </b-list-group-item>
                      <b-list-group-item
                        class="list-variable-item"
                      >
                        <b-row>
                          <b-col
                            v-for="variable in processmodule.module_settings"
                            :key="variable.id"
                            cols="12"
                            md="4"
                            class="group-col"
                          >
                            <b-form-group
                              :label="$t(variable.label)"
                              label-for="h-first-name"
                              label-cols-md="12"
                              class="process-group"
                            >
                              <label>{{ variable.value === 'dato_felt' ? getDatoFelto(variable.functional_value) : variable.value }}</label>
                            </b-form-group>
                          </b-col>
                        </b-row>
                      </b-list-group-item>
                    </b-list-group>
                  </div>
                </b-alert>
              </b-col>
              <b-col
                v-if="processmodule.module_id === 16 && processmodule.depends_on === 0"
                :key="processmodule.id"
                cols="12"
                md="12"
                class="main-cols"
              >
                <b-alert
                  variant="primary"
                  show
                >
                  <h4 class="alert-heading">
                    {{ processmodule.module_title }}
                  </h4>
                  <div class="alert-body">
                    <b-list-group
                      flush
                      class="awaitlist"
                    >
                      <b-list-group-item
                        class="main-items"
                      >
                        {{ $t('DEBTIA_APPLY_TERMSHEET_TO') }} : {{ processmodule.module_settings ? processmodule.module_settings.termsheet_for : 'N/A' }}
                      </b-list-group-item>
                      <b-list-group-item
                        class="main-items"
                      >
                        {{ $t('DEBTIA_TERMSHEET') }} : {{ processmodule.module_settings ? processmodule.module_settings.termsheet : 'N/A' }}
                      </b-list-group-item>
                    </b-list-group>
                  </div>
                </b-alert>
              </b-col>
              <b-col
                v-if="(processmodule.module_id === 17 || processmodule.module_id === 25) && processmodule.depends_on === 0"
                :key="processmodule.id"
                cols="12"
                md="12"
                class="main-cols"
              >
                <b-alert
                  variant="primary"
                  show
                >
                  <condition-details
                    :ref="'processmodule-'+processmodule.id"
                    :module-settings="processmodule"
                    :parent-module="processmodule.id"
                    :condition-check="conditionCheck"
                    :state="0"
                    :api-process-modules="APIprocessmodules"
                    :contact-options="contactOptions"
                    @addChildModule="addConditionModule($event)"
                  />
                </b-alert>
              </b-col>
              <b-col
                v-if="(processmodule.module_id === 18) && processmodule.depends_on === 0"
                :key="processmodule.id"
                cols="12"
                md="12"
                class="main-cols"
              >
                <b-alert
                  variant="primary"
                  show
                >
                  <h4 class="alert-heading">
                    {{ processmodule.module_title }}
                  </h4>
                  <div class="alert-body">
                    <b-list-group
                      flush
                      class="awaitlist"
                    >
                      <b-list-group-item
                        class="main-items"
                      >
                        {{ $t('DEBTIA_OPERATOR') }} : {{ processmodule.module_settings ?
                          processmodule.module_settings.bailiff_status === 1 ? "True" : "False"
                          : 'N/A' }}
                      </b-list-group-item>
                    </b-list-group>
                  </div>
                </b-alert>
              </b-col>
              <b-col
                v-if="processmodule.module_id === 19 && processmodule.depends_on === 0"
                :key="processmodule.id"
                cols="12"
                md="12"
                class="main-cols"
              >
                <b-alert
                  variant="primary"
                  show
                >
                  <h4 class="alert-heading">
                    {{ processmodule.module_title }}
                  </h4>
                  <div class="alert-body">
                    <b-list-group
                      flush
                      class="awaitlist"
                    >
                      <b-list-group-item
                        class="main-items"
                      >
                        {{ processmodule.module_settings.court }}
                      </b-list-group-item>
                    </b-list-group>
                  </div>
                </b-alert>
              </b-col>
              <b-col
                v-if="processmodule.module_id === 20 && processmodule.depends_on === 0"
                :key="processmodule.id"
                cols="12"
                md="12"
                class="main-cols"
              >
                <b-alert
                  variant="primary"
                  show
                >
                  <h4 class="alert-heading">
                    {{ processmodule.module_title }}
                  </h4>
                  <div class="alert-body">
                    <b-list-group
                      flush
                      class="awaitlist"
                    >
                      <b-list-group-item
                        class="main-items"
                      >
                        {{ processmodule.module_settings.message }}
                      </b-list-group-item>
                    </b-list-group>
                  </div>
                </b-alert>
              </b-col>
              <b-col
                v-if="processmodule.module_id === 21 && processmodule.depends_on === 0"
                :key="processmodule.id"
                cols="12"
                md="12"
                class="main-cols"
              >
                <b-alert
                  variant="primary"
                  show
                >
                  <h4 class="alert-heading">
                    {{ processmodule.module_title }}
                  </h4>
                  <div class="alert-body">
                    <b-list-group
                      flush
                      class="awaitlist"
                    >
                      <b-list-group-item
                        class="main-items"
                      >
                        {{ $t('DEBTIA_REASON') }}: {{ getDebtiaReason(processmodule.module_settings.reason) }}
                      </b-list-group-item>
                    </b-list-group>
                  </div>
                </b-alert>
              </b-col>
              <b-col
                v-if="processmodule.module_id === 22 && processmodule.depends_on === 0"
                :key="processmodule.id"
                cols="12"
                md="12"
                class="main-cols"
              >
                <b-alert
                  v-if="processmodule.module_id === 22"
                  variant="primary"
                  show
                  class="mt-2"
                >
                  <h4 class="alert-heading">
                    {{ processmodule.module_title }}
                  </h4>
                  <div class="alert-body">
                    <b-list-group
                      flush
                      class="awaitlist"
                    >
                      <b-list-group-item
                        class="main-items"
                      >
                        {{ $t('DEBTIA_BAILIFF_PROCESS') }}
                      </b-list-group-item>
                    </b-list-group>
                  </div>
                </b-alert>
              </b-col>
              <b-col
                v-if="processmodule.module_id === 23 && processmodule.depends_on === 0"
                :key="processmodule.id"
                cols="12"
                md="12"
                class="main-cols"
              >
                <b-alert
                  v-if="processmodule.module_id === 23"
                  variant="primary"
                  show
                  class="mt-2"
                >
                  <h4 class="alert-heading">
                    {{ processmodule.module_title }}
                  </h4>
                  <div class="alert-body">
                    <b-list-group
                      flush
                      class="awaitlist"
                    >
                      <b-list-group-item
                        class="main-items"
                      >
                        {{ $t('DEBTIA_DEFAULT_OVERVAGNING_TERMSHEET') }}
                      </b-list-group-item>
                    </b-list-group>
                  </div>
                </b-alert>
              </b-col>
              <b-col
                v-if="processmodule.module_id === 24 && processmodule.depends_on === 0"
                :key="processmodule.id"
                cols="12"
                md="12"
                class="main-cols"
              >
                <b-alert
                  v-if="processmodule.module_id === 24"
                  variant="primary"
                  show
                  class="mt-2"
                >
                  <h4 class="alert-heading">
                    {{ processmodule.module_title }}
                  </h4>
                  <div class="alert-body">
                    <b-list-group
                      flush
                      class="awaitlist"
                    >
                      <b-list-group-item class="main-items">
                        {{ $t('DEBTIA_QUESTION') }}: {{ processmodule.module_settings.question }}
                      </b-list-group-item>
                      <b-list-group-item class="main-items">
                        {{ $t('DEBTIA_DESCRIPTION') }}: {{ processmodule.module_settings.description }}
                      </b-list-group-item>
                    </b-list-group>
                  </div>
                </b-alert>
              </b-col>
              <b-col
                v-if="processmodule.module_id === 26 && processmodule.depends_on === 0"
                :key="processmodule.id"
                cols="12"
                md="12"
                class="main-cols"
              >
                <b-alert
                  variant="primary"
                  show
                >
                  <h4 class="alert-heading">
                    {{ processmodule.module_title }}
                  </h4>
                  <div class="alert-body">
                    <b-list-group
                      flush
                      class="awaitlist"
                    >
                      <b-list-group-item
                        class="main-items"
                      >
                        Active Installment Plan will be deactivated.
                      </b-list-group-item>
                    </b-list-group>
                  </div>
                </b-alert>
              </b-col>
            </template>
          </b-row>
          <b-row
            v-else
          >
            <b-col
              cols="12"
              md="12"
            >
              <b-alert
                variant="warning"
                show
              >
                <h4 class="alert-heading">
                  {{ $t('DEBTIA_NO_MODULE_MSG') }}
                </h4>
              </b-alert>
            </b-col>
          </b-row>
        </div>
      </b-card>
    </b-overlay>
  </div>
</template>
<!-- eslint-disable no-param-reassign -->
<script>
import {
  BButton, BRow, BCol, BCard, BOverlay, BAlert, BListGroup, BListGroupItem, BFormGroup, BFormInput, BInputGroup,
} from 'bootstrap-vue'
import axios from '@axios'
import Ripple from 'vue-ripple-directive'
import { EventBus } from '@/event-bus'
import vSelect from 'vue-select'
import constants from '@/app-configs/constants'
import Vue from 'vue'
import axiosletter from '../../../libs/axiosletter'
import axiosEmail from '../../../libs/axiosemail'
import ConditionDetails from './ConditionDetails.vue'
// import UserActionDetails from './UserActionDetails.vue'
import AwaitModuleCopy from './AwaitModuleCopy.vue'
import SendLetterOrEmail from './SendLetterOrEmail.vue'

// Create a reactive state using Vue.observable
const sharedState = Vue.observable({
  apiLetterData: [], // Placeholder for API data
  apiEmailData: [],
  fileCategories: [{
    label: 'Base Documents', value: 'baseDocuments',
  }],
  conditions: [],
  templateVariableOptions: [],
  AirportsData: [],
  specialOptions: [],
  CaseGroups: [],
  letterClient: '',
  letterSecret: '',
  emailClient: '',
  emailSecret: '',
  statementConditionID: 0,
  interestTypeConditionID: 0,
  customVarsArgs: [],
  customVars: [],
  CustomVarsForInt: [],
  contactOptions: [],
  prevModuleOptions: [],
})

const DEBTIA_REASON_DESCRIPTIONS = {
  BET: 'Fordring betalt',
  AIN: 'Aftale indgået med skyldner',
  DØD: 'Skyldner er afgået ved døden',
  TFY: 'Tvangsakkord fyldestgjort',
  GAL: 'Gældssanering – al gæld bortfalder',
  VTT: 'Varen taget retur',
  TAF: 'Tvangsauktion aflyst',
  STR: 'Der er strid i sagen',
  DER: 'Andet – vi ønsker skyldner slettet',
}

export default {
  components: {
    BFormGroup,
    BButton,
    BRow,
    BCol,
    BCard,
    BOverlay,
    BAlert,
    BListGroup,
    BListGroupItem,
    ConditionDetails,
    SendLetterOrEmail,
    // UserActionDetails,
    AwaitModuleCopy,
    vSelect,
    BFormInput,
    BInputGroup,
  },
  provide() {
    return {
      sharedState, // Provide the reactive state
    }
  },
  directives: {
    Ripple,
  },
  data() {
    return {
      loader: false,
      conditionLoader: false,
      processtitle: '',
      processType: '',
      processPaused: false,
      APIprocessmodules: [],
      filteredAPIprocessmodules: [],
      dependedModules: [],
      initialState: {
        depends_on: 0,
        parentID: 0,
      },
      awaitmoduleadded: false,
      processes: [],
      caseReasonOptions: [],
      specialOptions: [
        { name: 'debtia.currencyConverter', label: 'DKK/EUR Converter' },
        { name: 'dato_felt', label: 'Select number of days after letter generation' },
        { name: 'auto_fik', label: '' },
        { name: 'debtia.recepient_name', label: 'Enter recepient name.' },
        { name: 'debtia.recepient_contact_person', label: 'Enter recepient contact person' },
        { name: 'debtia.recepient_road_name', label: 'Enter recepient address road name' },
        { name: 'debtia.recepient_house_number', label: 'Enter recepient house number' },
        { name: 'debtia.recepient_zipcode', label: 'Enter recepient zipcode' },
        { name: 'debtia.recepient_city', label: 'Enter recepient city' },
        { name: 'debtia.recepient_country', label: 'Enter recepient country' },
        { name: 'debtia.recepient_place', label: 'Enter recepient place' },
        { name: 'module_run_date', label: 'Module Run Date' },
        { name: 'interest_rate_percentage', label: 'Interest Rate Percentage' },
        { name: 'conditional_mappable', label: 'Conditional Mappable' },
        { name: 'letter_sent_date', label: 'Letter Sent Date' },
        { name: 'debtia.freeText', label: 'Free Text' },
        { name: 'debtia.paymentLink', label: 'Payment Link' },
      ],
      conditionDiv: 0,
      conditionVariant: {},
      conditionCheck: true,
      maincondition: true,
      letterTemplates: [],
      emailTemplates: [],
      fileCategories: [{
        label: 'Base Documents', value: 'baseDocuments',
      }],
      letter_client_id: '',
      letter_secret: '',
      email_client_id: '',
      email_secret: '',
      templateVariableOptions: [],
      conditions: [],
      AirportsData: [],
      statementConditionID: 0,
      interestTypeConditionID: '',
      processTitleError: false,
      CaseGroups: [],
      customVarsArgs: [],
      customVars: [],
      CustomVarsForInt: [],
      customVarsFor: 'debtor',
      allModulesCopy: [],
      contactOptions: [],
      letterTemplatesCheck: false,
      emailTemplatesCheck: false,
      contactOptionsCheck: false,
      componentObject: {},
      SubStatementOptions: [],
      prevModuleOptions: [],
      emptyvalues: 0,
      haltBtn: false,
      paymentEmailTemplate: 0,
    }
  },
  async created() {
    await this.getLetterApiSettings()
    await this.getEmailApiSettings()
    await this.getTemplateId()
    this.getPreviousModules()
    this.getSubStatements()
    this.getConditions()
    this.getCustomVars()
    this.getCaseGroups()
    this.getProcesses()
    this.getCaseReasonOptions()
    this.attachVariables()
    this.getFileCategories()
    this.getContacts()
    await this.getProcess(this.initialState)
    EventBus.$on('changeCopyModuleTemplateVariable', obj => {
      if (obj.dependsOn === 0) this.getVariables(obj)
    })
    EventBus.$on('haltProcessCopyBtn', v => {
      this.handleBtn(v)
    })
    // EventBus.$on('addModuleInButton', obj => {
    //   this.conditionVariant = obj
    //   this.conditionCheck = !this.conditionCheck
    // })
    EventBus.$on('expandDetailsInConditionModuleCopy', obj => {
      this.$refs[`processmodule-${obj.main}`][0].expandfunction(obj)
    })
    EventBus.$on('refreshBackCopy', obj => {
      this.$refs[`processmodule-${obj.main}`][0].expandCondition(obj.id)
    })
  },
  methods: {
    handleBtn(msg) {
      this.haltBtn = msg
    },
    async getContacts() {
      this.contactOptionsCheck = false
      await axios.get('/contacts/get-all?dropdown=true').then(contacts => {
        if (contacts.status) {
          const options = contacts.data.data
          options.forEach(element => {
            const elementObj = { label: element.name, value: element.id }
            this.contactOptions.push(elementObj)
          })
          this.contactOptionsCheck = true
        }
      })
    },
    async getCustomVars() {
      await axios.get('/get-all-custom-vars').then(response => {
        if (response.status === 200) {
          this.customVarsArgs.push(...response.data.data)
          this.customVars = this.customVarsArgs.filter(e => e.var_for === this.customVarsFor)
          const customVarsForIntType = this.customVarsArgs.filter(e => e.var_for === 'case' && e.var_type === 'number')
          this.CustomVarsForInt = [{ label: 'Add custom number', value: 'literal' },
            ...customVarsForIntType]
          sharedState.customVarsArgs = this.customVarsArgs
          sharedState.customVars = this.customVars
          sharedState.CustomVarsForInt = this.CustomVarsForInt
        }
      }).catch(error => console.log(error))
    },
    async getCaseGroups() {
      await axios.get('/debt-case-groups-dropdown').then(response => {
        if (response.status === 200) {
          this.CaseGroups.push(...response.data.data)
          sharedState.CaseGroups = this.CaseGroups
        }
      }).catch(error => console.log(error))
    },
    checktitle() {
      this.processTitleError = false
      if (!this.processtitle) {
        this.processTitleError = true
      }
    },
    getAwaitBody(e) {
      const obj = {
        module_id: e.module_id,
        module_order: 1,
        number_of_days: e.module_settings.number_of_days,
        type: e.module_settings.type,
        depends_on: e.depends_on,
        condition: e.condition,
        skip_monday: e.module_settings.skip_monday,
        skip_interest_calculation: e.module_settings.skip_interest_calculation,
      }
      return obj
    },
    getChangeStateBody(e) {
      const obj = {
        module_id: e.module_id,
        module_order: 1,
        new_process_id: e.module_settings.new_process_id,
        depends_on: e.depends_on,
        condition: e.condition,
      }
      return obj
    },
    getLetterOrEmailModuleBody(e) {
      const obj = this.$refs[`section-${e.id}`][0].getTheObject(e.condition, e.depends_on)
      return obj
    },
    getTheEmailOrLetterObject(e) {
      const customVariables = {}
      e.module_settings.custom_variables.forEach(element => {
        if (element.value === 'debtia.currencyConverter') {
          const statementObject = element.data.fields[0].options.filter(el => el.value === element.data.fields[0].value)
          const internalObj = {
            variable: element.value,
            functional_value: null,
            currency_id: element.data.fields[1].value,
            statement_id: element.data.fields[0].value,
            statement_type: statementObject[0].type,
          }
          customVariables[element.variable] = internalObj
        } else if (element.value === 'dato_felt') {
          const internalObj = {
            variable: element.value,
            functional_value: element.functional_value,
          }
          customVariables[element.variable] = internalObj
        } else if (element.value === 'module_run_date') {
          const internalObj = {
            variable: element.value,
            functional_value: Number(element.data.fields[0].value),
          }
          customVariables[element.variable] = internalObj
        } else if (element.value === 'interest_rate_percentage') {
          const internalObj = {
            variable: element.value,
            functional_value: null,
            base_types: element.data.fields[0].value,
            document_order: element.data.fields[1].value,
          }
          customVariables[element.variable] = internalObj
        } else if (element.value === 'letter_sent_date') {
          const filteredData = this.letterTemplates.filter(item => element.data.fields[0].value.includes(item.value)).map(item => ({ id: item.value, title: item.label }))
          const internalObj = {
            variable: element.value,
            functional_value: null,
            letters: filteredData,
            order: element.data.fields[1].value,
          }
          customVariables[element.variable] = internalObj
        } else if (element.value === 'debtia.freeText') {
          const internalObj = {
            variable: element.value,
            functional_value: null,
            free_text_note: element.data.fields[0].value,
          }
          customVariables[element.variable] = internalObj
        } else if (element.value === 'debtia.case_presentation') {
          // const filteredData = this.letterTemplates.filter(item => element.data.fields[0].value.includes(item.value)).map(item => ({ id: item.value, title: item.label }))
          const internalObj = {
            variable: element.value,
            functional_value: element.functional_value,
            letters: [],
            order: null,
          }
          customVariables[element.variable] = internalObj
        } else {
          customVariables[element.variable] = element.value
        }
      })
      customVariables.receipients = {
        key: e.module_settings.receipients.variable,
        value: e.module_settings.receipients.value,
        contact_id: 0,
      }
      const obj = {
        module_id: e.module_id,
        module_order: 1,
        letter_template_id: e.module_settings.letter_template_id,
        custom_variables: customVariables,
        letter_template_title: e.module_settings.letter_template_title,
        fileCategory: e.module_settings.file_groups,
        attach_base_documents: false,
        depends_on: e.depends_on,
        condition: e.condition,
      }
      return obj
    },
    getInnerConditionMainObject(e) {
      let fileCategory = 0
      let CaseGroup = 0
      let customVariableValue = ''
      let optionValue = 0
      let statementValue = 0
      let interestType = ''
      let customVariableId = 0
      let clientCollectionType = ''
      let clientType = ''
      const StatementsArgs = []
      const conditionValue = e.module_settings.operator === 1 ? 1 : 0
      this.conditions.forEach(e2 => {
        if (e.module_settings.condition_id === e2.value) {
          if (e2.type === 'select' && e2.customVarID > 0) {
            optionValue = e.module_settings?.optionValue ?? e.module_settings.fields[0].value
          }
          fileCategory = e.module_settings.condition_id === 5 ? e.module_settings?.fileCategory ?? e.module_settings.fields[0].value : 0
          CaseGroup = e.module_settings.condition_id === 6 ? e.module_settings?.CaseGroup ?? e.module_settings.fields[0].value : 0
          customVariableId = e2.customVarID
          customVariableValue = customVariableId > 0 ? e.module_settings?.customVariableValue ?? e.module_settings.fields[0].value : ''
          statementValue = e.module_settings.statement ? e.module_settings?.fields[1].value ?? 0 : 0
          const interestTypeID = e2.label === 'Is Interest Type Custom?' ? e2.value : 0
          interestType = e.module_settings.condition_id === interestTypeID ? e.module_settings?.interestType ?? e.module_settings.fields[0]?.value ?? '' : ''
          const clientCollectionTypeID = e2.label === 'Is client Collection Type?' ? e2.value : 0
          clientCollectionType = e.module_settings.condition_id === clientCollectionTypeID ? e.module_settings?.clientCollectionType ?? e.module_settings.fields[0]?.value ?? '' : ''
          const clientTypeID = e2.label === 'Check client type' ? e2.value : 0
          clientType = e.module_settings.condition_id === clientTypeID ? e.module_settings?.clientTypeValue ?? e.module_settings.fields[0]?.value ?? '' : ''
          if (e.module_settings.statement) {
            e.module_settings.fields[0].value.map(e3 => e.module_settings.fields[0].options.filter(el => {
              if (e3 === el.value) {
                StatementsArgs.push({
                  statement_id: el.value,
                  statement_type: el.type,
                })
              }
              return StatementsArgs
            }))
          }
        }
      })
      const toMake = {
        company_custom_var_id: 0,
        condition_id: e.module_settings.condition_id,
        condition_operator_id: e.module_settings.operator,
        // eslint-disable-next-line no-nested-ternary
        condition_value: e.module_settings.operator > 2 ? e.module_settings?.condition_value ?? statementValue > 0 ? e.module_settings?.condition_value ?? statementValue : 0 : Number(conditionValue),
        custom_option_id: e.module_settings?.optionValue ?? optionValue,
        custom_variable_id: e.module_settings?.CustomVarID ?? customVariableId,
        custom_variable_value: e.module_settings?.customVariableValue ?? customVariableValue,
        dacustom_variable_value: '',
        date_type: e.module_settings?.date_type ?? null,
        file_category_id: e.module_settings?.fileCategory ?? fileCategory,
        group_id: e.module_settings?.CaseGroup ?? CaseGroup,
        interest_type_condition: e.module_settings?.interestType ?? interestType,
        module_id: e.module_id,
        module_order: 1,
        no_of_passengers: 0,
        sub_statements: e.module_settings?.statements ?? StatementsArgs,
        days: e.module_settings.no_of_days,
        condition: e.condition,
        depends_on: e.depends_on,
        skip_interest_calculation: e.module_settings.skip_interest_calculation,
        skip_monday: e.module_settings.skip_monday,
        client_collection_type: e.module_settings?.clientCollectionType ?? clientCollectionType,
        client_type: e.module_settings?.clientTypeValue ?? clientType,
        question: e.module_settings?.question ?? '',
        description: e.module_settings?.description ?? '',
      }
      return toMake
    },
    getConditionMainObject(e) {
      const conditionValue = e.module_settings.operator === 1 ? 1 : 0
      const toMake = {
        condition: e.condition,
        company_custom_var_id: 0,
        condition_id: e.module_settings.condition_id,
        condition_operator_id: e.module_settings.operator,
        // eslint-disable-next-line no-nested-ternary
        condition_value: e.module_settings.operator > 2 ? e.module_settings.condition_value > 0 ? e.module_settings.condition_value : 0 : Number(conditionValue),
        custom_option_id: e.module_settings.optionValue,
        custom_variable_id: e.module_settings.CustomVarID,
        custom_variable_value: e.module_settings.customVariableValue,
        dacustom_variable_value: '',
        date_type: e.module_settings.date_type,
        file_category_id: e.module_settings.fileCategory,
        group_id: e.module_settings.CaseGroup,
        interest_type_condition: e.module_settings.interestType,
        module_id: e.module_id,
        module_order: 1,
        no_of_passengers: 0,
        sub_statements: e.module_settings.statements,
        days: e.module_settings.no_of_days,
        skip_interest_calculation: e.module_settings.skip_interest_calculation,
        skip_monday: e.module_settings.skip_monday,
        question: e.module_settings.question,
        description: e.module_settings.description,
      }
      return toMake
    },
    async saveProcess() {
      this.emptyvalues = 0
      if (!this.processTitleError) {
        const arr = []
        const newArr = this.processArray()
        for (const element of newArr) {
          if (element.module_id === 1) {
            const obj = this.getAwaitBody(element)
            if (obj.number_of_days === '' || !obj.number_of_days) {
              this.emptyvalues += 1
            }
            arr.push(obj)
          }
          if (element.module_id === 5) {
            const obj = this.getChangeStateBody(element)
            arr.push(obj)
          }
          if (element.module_id === 2 || element.module_id === 14) {
            const newElement = this.getInnerConditionMainObject(element)
            this.checkConditionVariableValues(newElement)
            arr.push(newElement)
          }
          if ((element.module_id === 3 || element.module_id === 4) && element.depends_on === null) {
            // console.log('elemeent is 3 ', element)
            // eslint-disable-next-line no-param-reassign
            element.payload.depends_on = null
            Object.entries(element.payload.custom_variables).forEach(e => {
              if (e[1].condition_mappable) {
                this.checkConditionVariableValues(e[1])
                this.checkVariableValues(e[1].true_value)
                this.checkVariableValues(e[1].false_value)
              } else {
                this.checkVariableValues(e[1])
              }
            })
            if (element.payload.fileCategory.length > 0 && this.emptyvalues === 0) {
              element.payload.fileCategory.filter((e, i) => {
                if (e === 'baseDocuments') {
                  element.payload.fileCategory.splice(i, 1)
                }
                return true
              })
            }
            arr.push(element.payload)
          }
          if ((element.module_id === 3 || element.module_id === 4) && (element.depends_on >= 0 && element.depends_on !== null)) {
            // eslint-disable-next-line no-param-reassign
            element.payload.depends_on = element.depends_on
            const obj = element.payload
            Object.entries(element.payload.custom_variables).forEach(e => {
              if (e[1].condition_mappable) {
                this.checkConditionVariableValues(e[1])
                this.checkVariableValues(e[1].true_value)
                this.checkVariableValues(e[1].false_value)
              } else {
                this.checkVariableValues(e[1])
              }
            })
            if (obj.fileCategory.length > 0 && this.emptyvalues === 0) {
              obj.fileCategory.filter((e, i) => {
                if (e === 'baseDocuments') {
                  obj.fileCategory.splice(i, 1)
                }
                return true
              })
            }
            arr.push(obj)
          }
          if (element.module_id === 6 || element.module_id === 7
          || element.module_id === 8 || element.module_id === 9
          || element.module_id === 10 || element.module_id === 11
          || element.module_id === 12 || element.module_id === 13
          || element.module_id === 15 || element.module_id === 16
          || element.module_id === 17 || element.module_id === 18
          || element.module_id === 19 || element.module_id === 20
          || element.module_id === 21 || element.module_id === 22
          || element.module_id === 23 || element.module_id === 24
          || element.module_id === 25 || element.module_id === 26) {
            arr.push(element.payload)
          }
        }
        if (this.emptyvalues === 0) {
          const payload = {
            title: this.processtitle,
            type: this.processType,
            pause_other_process: this.processPaused,
            modules: arr,
          }
          await axios.post('/process/copy', payload).then(response => {
            if (response.status === 200) {
              this.$router.push({ name: 'processes' })
            }
          }).catch(error => console.log(error))
        }
      }
    },
    checkConditionVariableValues(subValue) {
      const condition = this.conditions.filter(e => e.value === subValue.condition_id)
      if (subValue.module_id === 14 && (subValue?.days === undefined || (subValue.days && (subValue.days === '' || subValue.days === null)))) {
        this.emptyvalues += 1
      }
      if (!subValue.condition_id || !subValue.condition_operator_id) {
        this.emptyvalues += 1
      }
      if (subValue.condition_id && subValue.condition_id === 5 && !subValue.file_category_id) {
        this.emptyvalues += 1
      }
      if (!subValue.module_id && subValue.condition_id && subValue.condition_id === 6 && !subValue.debt_case_group_id) {
        this.emptyvalues += 1
      }
      if (subValue.module_id && (subValue.module_id === 2 || subValue.module_id === 14)
      && (subValue.condition_id && subValue.condition_id === 6) && !subValue.group_id) {
        this.emptyvalues += 1
      }
      if (subValue.condition_id && condition[0].label.toLowerCase() === 'is the field filled?' && !subValue.custom_variable_id) {
        this.emptyvalues += 1
      }
      if (subValue.condition_id && condition[0].label.toLowerCase() === 'statements' && (!subValue.condition_value || !subValue.sub_statements || (subValue.sub_statements && subValue.sub_statements.length === 0))) {
        this.emptyvalues += 1
      }
      if (subValue.condition_id && condition[0].label.toLowerCase() === 'is interest type custom?' && !subValue.interest_type_condition) {
        this.emptyvalues += 1
      }
      if (subValue.condition_id && condition[0].label.toLowerCase() === 'is client collection type?' && subValue.client_collection_type === '') {
        this.emptyvalues += 1
      }
      if (subValue.condition_id && condition[0].label.toLowerCase() === 'check client type' && subValue.client_type === '') {
        this.emptyvalues += 1
      }
      if (condition[0].customVarID > 0
      && (condition[0].type === 'string' || condition[0].type === 'number' || condition[0].type === 'multiline string')
      && (!subValue.custom_variable_value || (subValue.custom_variable_value && subValue.custom_variable_value === ''))) {
        this.emptyvalues += 1
      }
      if (condition[0].customVarID > 0
      && (condition[0].type === 'select')
      && (subValue.custom_option_id !== undefined && subValue.custom_option_id < 1)) {
        this.emptyvalues += 1
      }
      if (condition[0].customVarID > 0
      && (condition[0].type === 'boolean') && (!subValue.custom_variable_value)) {
        this.emptyvalues += 1
      }
      if (condition[0].customVarID > 0
      && (condition[0].type === 'boolean') && (!subValue.custom_variable_value)) {
        this.emptyvalues += 1
      }
      if ((subValue.module_id !== 14 && subValue.module_id !== 2) && condition[0].customVarID > 0 && (condition[0].type === 'date' && !subValue.dateOption)) {
        this.emptyvalues += 1
      }
      if ((subValue.module_id === 14 || subValue.module_id === 2) && condition[0].customVarID > 0 && (condition[0].type === 'date' && !subValue.date_type)) {
        this.emptyvalues += 1
      }
      if ((subValue.module_id !== 14 && subValue.module_id !== 2) && condition[0].customVarID > 0
        && (condition[0].type === 'date' && subValue.dateOption
          && (!subValue.custom_variable_value || (subValue.custom_variable_value && subValue.custom_variable_value === '')))) {
        this.emptyvalues += 1
      }
      if ((subValue.module_id === 14 || subValue.module_id === 2) && condition[0].customVarID > 0
        && (condition[0].type === 'date' && subValue.date_type
          && (!subValue.custom_variable_value || (subValue.custom_variable_value && subValue.custom_variable_value === '')))) {
        this.emptyvalues += 1
      }
      if (condition[0].customVarID > 0
        && (condition[0].type === 'time'
          && (!subValue.custom_variable_value || (subValue.custom_variable_value && subValue.custom_variable_value === '')))) {
        this.emptyvalues += 1
      }
    },
    checkVariableValues(subValue) {
      if (subValue.variable === 'debtia.currencyConverter' && (!subValue.currency_id || !subValue.statement_id)) {
        this.emptyvalues += 1
      } else if (subValue.variable === 'module_run_date' && (!subValue.functional_value || subValue.functional_value === '')) {
        // eslint-disable-next-line no-unused-expressions
        subValue.functional_value !== 0 ? this.emptyvalues += 1 : ''
      } else if (subValue.variable === 'letter_sent_date' && (!subValue.letters || (subValue.letters && subValue.letters.length === 0) || !subValue.order)) {
        this.emptyvalues += 1
      } else if (subValue.variable === 'debtia.freeText' && (!subValue.free_text_note || subValue.functional_value === '')) {
        this.emptyvalues += 1
      } else if (subValue.variable === 'interest_rate_percentage' && (!subValue.base_types || (subValue.base_types && subValue.base_types.length === 0) || !subValue.document_order)) {
        this.emptyvalues += 1
      } else if (subValue.value === 'debtia.receipientsContact' && subValue.contact_id === 0) {
        this.emptyvalues += 1
      } else if (!subValue) {
        this.emptyvalues += 1
      }
    },
    sortAndUpdateDependsOn(modules) {
      // Step 1: Create a mapping of IDs to their index in the original array
      const idToIndexMap = {}
      const sortedItems = []

      // Step 2: Sort items into a logical order based on dependencies
      const sortedIds = modules
        .slice()
        .sort((a, b) => a.depends_on - b.depends_on)

      // Step 3: Create a new array, updating the `depends_on` property to use indices
      sortedIds.forEach((item, index) => {
        idToIndexMap[item.id] = index
        sortedItems.push({
          ...item,
          depends_on: item.depends_on === 0 ? null : idToIndexMap[item.depends_on],
        })
      })

      // Step 4: Update sortedArray in the component state
      return sortedItems
    },
    getVariables(obj) {
      setTimeout(() => {
        this.haltBtn = true
        this.$refs[obj.sectionID][0].changeTemplateVariables(obj.id)
      }, 500)
    },
    async getFileCategories() {
      await axios.get('/settings/file-categories-dropdown').then(response => {
        if (response.status === 200) {
          this.fileCategories.push(...response.data.data)
          sharedState.fileCategories = this.fileCategories
        }
      }).catch(error => console.log(error))
    },
    async getConditions() {
      this.busy = true
      await axios.get('/process/get-conditions').then(response => {
        if (response.status === 200) {
          const conditionsData = response.data.data.variables.map(e => ({
            ...e, label: this.$t(e.label), value: e.value,
          }))
          this.conditions.push(...conditionsData)
          this.AirportsData.push(...response.data.data.airports)
          const conditionID = this.conditions.filter(e => e.label === 'Statements')
          this.statementConditionID = conditionID.length > 0 ? conditionID[0].value : 0
          const interestTypeID = this.conditions.filter(e => e.label === 'Is Interest Type Custom?')
          this.interestTypeConditionID = interestTypeID.length > 0 ? interestTypeID[0].value : 0
          this.busy = false
          sharedState.interestTypeConditionID = this.interestTypeConditionID
          sharedState.statementConditionID = this.statementConditionID
          sharedState.conditions = this.conditions
          sharedState.AirportsData = this.AirportsData
        }
      }).catch(error => console.log(error))
    },
    async attachVariables() {
      this.templateVariableOptions = [
        { label: 'clients.id', value: 'clients.id' },
        { label: 'clients.name', value: 'clients.name' },
        { label: 'clients.roadname', value: 'clients.roadname' },
        { label: 'clients.house_no', value: 'clients.house_no' },
        { label: 'clients.zipcode', value: 'clients.zipcode' },
        { label: 'clients.city', value: 'clients.city' },
        { label: 'clients.cvr', value: 'clients.cvr' },
        { label: 'clients.email', value: 'clients.email' },
        { label: 'debtors.name', value: 'debtors.name' },
        { label: 'debtors.phone', value: 'debtors.phone' },
        { label: 'debtors.email', value: 'debtors.email' },
        { label: 'debtors.contact_person', value: 'debtors.contact_person' },
        { label: 'debtor_addresses.road_name', value: 'debtor_addresses.road_name' },
        { label: 'debtor_addresses.house_no', value: 'debtor_addresses.house_no' },
        { label: 'debtor_addresses.zip_code', value: 'debtor_addresses.zip_code' },
        { label: 'debtor_addresses.city', value: 'debtor_addresses.city' },
        { label: 'debt_case_info.payment_amount', value: 'debt_case_info.payment_amount' },
        { label: 'debt_case_info.interest_rate_percentage', value: 'debt_case_info.interest_rate_percentage' },
        { label: 'debt_case_info.reminder_fee', value: 'debt_case_info.reminder_fee' },
        { label: 'debt_case_info.paid_amount', value: 'debt_case_info.paid_amount' },
        { label: 'debt_case_info.credit_note_amount', value: 'debt_case_info.credit_note_amount' },
        { label: 'debt_case_info.total_amount', value: 'debt_case_info.total_amount' },
        { label: 'debt_cases.id', value: 'debt_cases.id' },
        { label: 'debtor.co', value: 'debtor.co' },
        { label: 'debtor.addresses.place', value: 'debtor.addresses.place' },
        { label: 'debt_case_info.principal', value: 'debt_case_info.principal' },
        { label: 'debt_case_info.principal_rest', value: 'debt_case_info.principal_rest' },
        { label: 'debt_case_info.interest_rest', value: 'debt_case_info.interest_rest' },
        { label: 'debt_case_info.collection_fee_rest', value: 'debt_case_info.collection_fee_rest' },
        { label: 'debt_case_info.compensation_cost_rest', value: 'debt_case_info.compensation_cost_rest' },
        { label: 'debt_case_info.reminder_fee_rest', value: 'debt_case_info.reminder_fee_rest' },
        { label: 'debt_case_info.collection_cost_rest', value: 'debt_case_info.collection_cost_rest' },
        { label: 'debt_case_info.salary_rest', value: 'debt_case_info.salary_rest' },
        { label: 'debt_case_info.total_rest', value: 'debt_case_info.total_rest' },
        { label: 'Court Name', value: 'court.name' },
        { label: 'Court Road Name', value: 'court.road_name' },
        { label: 'Court House Number', value: 'court.house_number' },
        { label: 'Court Zipcode', value: 'court.zipcode' },
        { label: 'Court City', value: 'court.city' },
        { label: 'Court Phone', value: 'court.phone' },
        { label: 'Court Email', value: 'court.email' },
        { label: 'Court Bank Registration Number', value: 'court.regNo' },
        { label: 'Court Bank Account Number', value: 'court.accountNo' },
        { label: 'Court Short Name', value: 'court.shortName' },
        { label: 'Base Type', value: 'debtia.baseType' },
        { label: 'String X', value: 'string_x' },
        { label: 'Base Document Titles', value: 'debtia.baseDocumentTitles' },
        { label: 'Date of first interest entry', value: 'interest.first_entry' },
        { label: 'Date of last interest entry', value: 'interest.last_entry' },
        { label: 'VAT Exempted Client', value: 'debtia.vat_exempted_client' },
        { label: 'Case Presentation', value: 'debtia.case_presentation' },
        { label: 'Debtor CVR/CPR', value: 'debtia.debtor_cvr_cpr' },
        { label: 'Active Installment Plan Creation Date', value: 'active_installment_plan_creation_date' },
        { label: 'Next Unpaid Installment Amount', value: 'next_unpaid_installment_amount' },
        { label: 'Next Unpaid Installment Date', value: 'next_unpaid_installment_date' },
        { label: 'List Of Unpaid Installments', value: 'list_of_unpaid_installments' },
        { label: 'DKK/EUR Converter', value: 'debtia.currencyConverter' },
        { label: 'dato felt', value: 'dato_felt' },
        { label: 'Auto FIK', value: 'auto_fik' },
        { label: 'Recepient Name', value: 'debtia.recepient_name' },
        { label: 'Recepient Contact Person', value: 'debtia.recepient_contact_person' },
        { label: 'Recepient Address Road Name', value: 'debtia.recepient_road_name' },
        { label: 'Recepient Address House Number', value: 'debtia.recepient_house_number' },
        { label: 'Recepient Address Zipcode', value: 'debtia.recepient_zipcode' },
        { label: 'Recepient Address City', value: 'debtia.recepient_city' },
        { label: 'Recepient Address Country', value: 'debtia.recepient_country' },
        { label: 'Recepient Address Place', value: 'debtia.recepient_place' },
        { label: 'Module Run Date', value: 'module_run_date' },
        { label: 'Interest Rate Percentage', value: 'interest_rate_percentage' },
        { label: 'Conditional Mappable', value: 'condition_mappable' },
        { label: 'Letter Sent Date', value: 'letter_sent_date' },
        { label: 'Free Text', value: 'debtia.freeText' },
        { label: 'Payment Link', value: 'debtia.paymentLink' },
      ]

      await axios.get(`${constants.serverBaseUrl}/api/v2/debtiaapp/process/get-custom-variables`).then(response => {
        if (response.status) {
          const index = this.templateVariableOptions.length - this.specialOptions.length
          this.templateVariableOptions.splice(index, 0, ...response.data.data)
        }
      })

      await axios.get('/process/get-statement-vars').then(response => {
        if (response.status) {
          const index = this.templateVariableOptions.length - this.specialOptions.length
          this.templateVariableOptions.splice(index, 0, ...response.data.data)
        }
      })
      sharedState.templateVariableOptions = this.templateVariableOptions
      sharedState.specialOptions = this.specialOptions
    },
    async getEmailApiSettings() {
      this.busy = true
      await axios.get('/api-token/default?module=communication').then(settings => {
        if (settings.status) {
          this.email_client_id = settings.data.data.client_id
          this.email_secret = settings.data.data.secret
          sharedState.emailClient = settings.data.data.client_id
          sharedState.emailSecret = settings.data.data.secret
        }
      })
      this.getEmailTemplate()
    },
    getEmailTemplate() {
      this.emailTemplatesCheck = false
      const url = '/v1/email/get-templates'
      const headers = {
        clientId: this.email_client_id,
        secret: this.email_secret,
      }
      axiosEmail.get(url, {
        headers,
      }).then(response => {
        if (response.status === 200) {
          const records = response.data.data
          records.forEach(element => {
            const elementObj = { label: element.name, value: element.id }
            this.emailTemplates.push(elementObj)
          })
          sharedState.apiEmailData = this.emailTemplates // Update the reactive state
          this.emailTemplatesCheck = true
        }
      })
    },
    async getLetterApiSettings() {
      this.busy = true
      await axios.get('/api-token/default?module=physical-letters').then(settings => {
        if (settings.status) {
          this.letter_client_id = settings.data.data.client_id
          this.letter_secret = settings.data.data.secret
          sharedState.letterClient = settings.data.data.client_id
          sharedState.letterSecret = settings.data.data.secret
        }
      })
      this.getLetterTemplate()
    },
    getProcesses() {
      const url = '/process/list?perPage=100000000&q=&page='
      axios.get(url).then(response => {
        if (response.status) {
          const records = response.data.data.processes.data
          records.forEach(element => {
            const elementObj = { label: element.title, value: element.id }
            this.processes.push(elementObj)
          })
        }
      })
    },
    addConditionModule(event) {
      this.conditionVariant = event
      this.conditionCheck = !this.conditionCheck
    },
    addMainModule(id) {
      const obj = {
        moduleID: id,
        type: 0,
      }
      this.conditionVariant = obj
      this.conditionCheck = !this.conditionCheck
    },
    async getProcess(event) {
      if (event.depend > 0) {
        this.$refs[`processmodule-${event.parentID}`][0].refreshModule(event.type)
      } else {
        this.loader = true
        const processID = this.$route.params.id
        const url = `/process/get-copy/${processID}`
        this.filteredAPIprocessmodules = []
        await axios.get(url).then(response => {
          if (response.status === 200) {
            this.loader = false
            this.processtitle = response.data.data.process.title
            this.processType = response.data.data.process.type
            this.processPaused = response.data.data.process.pause_other_process
            this.allModulesCopy = response.data.data.process_modules
            this.APIprocessmodules = response.data.data.process_modules
            this.APIprocessmodules.forEach((element, i) => {
              // eslint-disable-next-line no-param-reassign
              element.index = i

              if (element.module_id === 3 || element.module_id === 4) {
                // eslint-disable-next-line no-param-reassign
                element.SubStatementOptions = this.SubStatementOptions
                // eslint-disable-next-line no-param-reassign
                element.payload = {}
                // eslint-disable-next-line no-param-reassign
                element.newCustomVariables = []
                const customVariables = {}
                element.module_settings.custom_variables.forEach(async (el, index) => {
                  // eslint-disable-next-line no-param-reassign
                  el.mappablePayload = {}
                  if (el.value === 'debtia.currencyConverter') {
                    const statementObject = element.module_settings.custom_variables[index].data.fields[0].options.filter(e => e.value === el.data.fields[0].value)
                    const internalObj = {
                      variable: el.value,
                      functional_value: null,
                      currency_id: el.data.fields[1].value,
                      statement_id: el.data.fields[0].value,
                      statement_type: statementObject[0].type,
                    }
                    customVariables[el.variable] = internalObj
                  } else if (el.value === 'dato_felt') {
                    const internalObj = {
                      variable: el.value,
                      functional_value: el.functional_value,
                    }
                    customVariables[el.variable] = internalObj
                  } else if (el.value === 'interest_rate_percentage') {
                    const internalObj = {
                      variable: el.value,
                      functional_value: null,
                      base_types: el.data.fields[0].value,
                      document_order: el.data.fields[1].value,
                    }
                    customVariables[el.variable] = internalObj
                  } else if (el.value === 'module_run_date') {
                    const internalObj = {
                      variable: el.value,
                      functional_value: el.data.fields[0].value,
                    }
                    customVariables[el.variable] = internalObj
                  } else if (el.value === 'letter_sent_date') {
                    const filteredData = this.letterTemplates.filter(item => el.data.fields[0].value.includes(item.value)).map(item => ({ id: item.value, title: item.label }))
                    const internalObj = {
                      variable: el.value,
                      functional_value: null,
                      letters: filteredData,
                      order: el.data.fields[1].value,
                    }
                    customVariables[el.variable] = internalObj
                  } else if (element.value === 'debtia.case_presentation') {
                    const filteredData = this.letterTemplates.filter(item => element.fields[0].includes(item.value)).map(item => ({ id: item.value, title: item.label }))
                    const internalObj = {
                      variable: element.value,
                      functional_value: element.fields[1],
                      letters: filteredData,
                      order: element.fields[1],
                    }
                    customVariables[el.variable] = internalObj
                  } else if (el.value === 'debtia.freeText') {
                    const internalObj = {
                      variable: el.value,
                      functional_value: null,
                      free_text_note: el.data.fields[0].value,
                    }
                    customVariables[el.variable] = internalObj
                  } else if (el.value === 'condition_mappable') {
                    this.componentObject = {}
                    // eslint-disable-next-line no-param-reassign
                    const trueFalseValues = {
                      condition_mappable: true,
                      functional_value: null,
                      condition_id: null, // req
                      condition_value: 0, // req (when statements is selected then the value of the input field)
                      subStatementValue: null,
                      condition_operator_id: null, // req
                      true_value: {},
                      false_value: {},
                      custom_variable_id: 0,
                      custom_option_id: 0,
                      custom_variable_value: 'debtor',
                      dacustom_variable_value: '',
                      file_category_id: 0,
                      debt_case_group_id: 0,
                      sub_statements: [],
                      dateOption: 1,
                      interest_type_condition: '',
                      letterTemplates: this.letterTemplates,
                      statements: [],
                      currentTemplateId: null,
                      currentTemplateTitle: '',
                      fieldObject: {},
                      client_collection_type: '',
                      client_type: '',
                    }
                    trueFalseValues.condition_id = el.data.conditions.value
                    trueFalseValues.condition_operator_id = el.data.operator
                    this.yesnoValueChanged(el.data.ifTrue, 1)
                    this.yesnoValueChanged(el.data.ifFalse, 0)
                    if (el.data.conditions.fields !== null) {
                      if (el.data.conditions.value === 5) trueFalseValues.file_category_id = el.data.conditions.fields[0].value
                      else if (el.data.conditions.value === 6) trueFalseValues.debt_case_group_id = el.data.conditions.fields[0].value
                      else if (el.data.conditions.value === 10) {
                        trueFalseValues.custom_variable_value = el.data.conditions.fields[0].value
                        trueFalseValues.custom_variable_id = el.data.conditions.fields[1].value
                      } else if (el.data.conditions.fields[0].label === 'Statements') {
                        el.data.conditions.fields[0].value.map(s => {
                          el.data.conditions.fields[0].options.filter(s2 => {
                            if (s === s2.value) {
                              trueFalseValues.sub_statements.push({
                                statement_id: s2.value,
                                statement_type: s2.type,
                              })
                            }
                            return true
                          })
                          return true
                        })
                        trueFalseValues.subStatementValue = el.data.conditions.fields[1].value
                        trueFalseValues.condition_value = el.data.conditions.fields[1].value
                      } else if (el.data.conditions.fields[0]?.collection_type === true) {
                        trueFalseValues.client_collection_type = el.data.conditions.fields[0].value
                      } else if (el.data.conditions.fields[0]?.client_type === true) {
                        trueFalseValues.client_type = el.data.conditions.fields[0].value
                      } else if (el.data.conditions.fields[0].type === 'select') {
                        trueFalseValues.custom_option_id = el.data.conditions.fields[0].value
                        trueFalseValues.custom_variable_id = el.data.custom_variable_id
                      } else if (el.data.conditions.fields[0].type === 'date') {
                        trueFalseValues.dateOption = el.data.conditions.fields[1].value
                        trueFalseValues.custom_variable_value = el.data.conditions.fields[0].value
                        trueFalseValues.custom_variable_id = el.data.custom_variable_id
                        // trueFalseValues.dacustom_variable_value = this.convertDate(el.data.conditions.fields[0].value)
                      } else {
                        trueFalseValues.custom_variable_value = el.data.conditions.fields[0].value
                        trueFalseValues.custom_variable_id = el.data.custom_variable_id
                      }
                    }
                    trueFalseValues.true_value = this.componentObject.true_value
                    trueFalseValues.false_value = this.componentObject.false_value
                    // eslint-disable-next-line no-param-reassign
                    el.mappablePayload = trueFalseValues
                    customVariables[el.variable] = trueFalseValues
                  } else if (el?.custom_variable === true) {
                    customVariables[el.variable] = {
                      custom_variable: true,
                      functional_value: null,
                      variable: el.value,
                    }
                  } else if (el.value === 'debtia.paymentLink') {
                    const internalObj = {
                      variable: el.value,
                      functional_value: null,
                      amount_based_plan: el.data.fields[0].value,
                      min_amount: el.data.fields[1].value,
                      period_based_plan: el.data.fields[2].value,
                      max_months: el.data.fields[3].value,
                      interest_free_months: el.data.fields[4].value,
                      payment_date: el.data.fields[5].value,
                      template_id: el.data.fields[6].value,
                      employee_name: el.data.fields[7].value,
                      module_type: el.data.fields[8].value,
                    }
                    customVariables[el.variable] = internalObj
                  } else {
                    customVariables[el.variable] = el.value
                  }
                })
                // eslint-disable-next-line array-callback-return
                const baseDocumentAttachments = element.module_settings.file_groups.filter(e => e === 'baseDocuments')
                customVariables.receipients = {
                  value: element.module_settings.receipients.value,
                  key: element.module_settings.receipients.variable,
                  contact_id: element.module_settings.receipients.contact_id,
                }
                const obj = {
                  // eslint-disable-next-line no-unneeded-ternary
                  attach_base_documents: baseDocumentAttachments.length > 0 ? true : false,
                  custom_variables: customVariables,
                  fileCategory: element.module_settings.file_groups,
                  module_id: element.module_id,
                  module_order: 1,
                  condition: element.condition,
                  depends_on: element.depends_on,
                  skip_email: element.module_settings.skip_email,
                }
                /* if ((element.depends_on && element.depends_on > 0) && (element.condition === 0 || element.condition === 1)) {
                  obj.condition = element.condition
                  obj.depends_on = element.depends_on
                } */
                if (element.module_id === 3) {
                  obj.letter_template_id = element.module_settings.letter_template_id
                  obj.letter_template_title = element.module_settings.letter_template_title
                } else {
                  obj.email_template_id = element.module_settings.email_template_id
                  obj.email_template_title = element.module_settings.email_template_title
                }
                // eslint-disable-next-line no-param-reassign
                element.payload = obj
              }
            })
          }
        })
      }
    },
    async getSubStatements() {
      await axios.get('/get-sub-statements').then(response => {
        if (response.status === 200) {
          this.sub_statements = ''
          this.SubStatementOptions.push(...response.data.data)
          // this.busy = false
        }
      }).catch(error => console.log(error))
    },
    getLetterTemplate() {
      this.letterTemplatesCheck = false
      const url = 'letters-api/list-all-letters?perPage=100000'
      const headers = {
        clientId: this.letter_client_id,
        secret: this.letter_secret,
      }
      axiosletter.get(url, {
        headers,
      }).then(response => {
        if (response.status === 200) {
          const records = response.data.data.data
          records.forEach(element => {
            const elementObj = { label: element.name, value: element.id }
            const exists = this.letterTemplates.some(
              item => item.label === elementObj.label && item.value === elementObj.value,
            )

            if (!exists) {
              this.letterTemplates.push(elementObj) // Push only if it doesn't exist
            }
          })
          sharedState.apiLetterData = this.letterTemplates // Update the reactive state
          this.letterTemplatesCheck = true
        }
      })
    },
    getState(id) {
      let processTitle = ''
      processTitle = this.processes.filter(entry => entry.value === id)
      return processTitle[0].label
    },
    getReason(id) {
      let reasonTitle = ''
      reasonTitle = this.caseReasonOptions.filter(entry => entry.value === id)
      return reasonTitle[0].label
    },
    getDebtiaReason(code) {
      const description = DEBTIA_REASON_DESCRIPTIONS[code]
      return description ? `${code} - ${description}` : code
    },
    async getCaseReasonOptions() {
      const url = '/get-reason-options'
      await axios.get(url).then(response => {
        if (response.status === 200) {
          this.caseReasonOptions = response.data.data
        }
      })
    },
    getDepenededModules(id) {
      const arr = this.dependedModules.filter(element => element.depends_on === id)
      return arr
    },
    getDatoFelto(number) {
      // eslint-disable-next-line no-nested-ternary
      return Number(number) === 0 ? 'dags dato' : (Number(number) >= 1 ? `dags dato (+${number} dage)` : `dags dato (${number} dage)`)
    },
    yesnoValueChanged(variable, type) {
      if (variable.value === 'debtia.currencyConverter') {
        const statementObject = variable.data.fields[0].options.filter(e => e.value === variable.data.fields[0].value)
        this.fieldObject = {
          stringtype: false,
          currency_id: variable.data.fields[1].value,
          functional_value: null,
          statement_id: variable.data.fields[0].value,
          statement_type: statementObject[0]?.type ?? '',
          variable: variable.value,
        }
      } else if (variable.value === 'dato_felt') {
        this.fieldObject = {
          stringtype: false,
          functional_value: variable.functional_value,
          variable: variable.value,
        }
      } else if (variable.value === 'module_run_date') {
        this.fieldObject = {
          stringtype: false,
          functional_value: variable.data.fields[0].value,
          variable: variable.value,
        }
      } else if (variable.value === 'interest_rate_percentage') {
        this.fieldObject = {
          stringtype: false,
          functional_value: null,
          base_types: variable.data.fields[0].value,
          document_order: variable.data.fields[1].value,
          variable: variable.value,
        }
      } else if (variable.value === 'letter_sent_date' || variable.value === 'debtia.case_presentation') {
        const filteredData = this.letterTemplates.filter(item => variable.data.fields[0].value.includes(item.value)).map(item => ({ id: item.value, title: item.label }))
        this.fieldObject = {
          stringtype: true,
          functional_value: null,
          letters: filteredData,
          order: variable.data.fields[1].value,
          variable: variable.value,
        }
      } else if (variable.value === 'debtia.freeText') {
        this.fieldObject = {
          stringtype: true,
          functional_value: null,
          free_text_note: variable.data.fields[0].value,
          variable: variable.value,
        }
      } else if (variable.value === 'debtia.paymentLink') {
        this.fieldObject = {
          stringtype: true,
          variable: variable.value,
          functional_value: null,
          amount_based_plan: variable.data.fields[0].value,
          min_amount: variable.data.fields[1].value,
          period_based_plan: variable.data.fields[2].value,
          max_months: variable.data.fields[3].value,
          interest_free_months: variable.data.fields[4].value,
          payment_date: variable.data.fields[5].value,
          template_id: variable.data.fields[6].value,
          employee_name: variable.data.fields[7].value,
          module_type: variable.data.fields[8].value,
        }
      } else {
        const customVar = this.templateVariableOptions.filter(e => e.value === variable.value && e.custom_variable === true)
        this.fieldObject = customVar.length > 0 ? {
          variable: variable.value,
          functional_value: null,
          custom_variable: true,
        } : {
          stringtype: true,
          variable: variable.value,
        }
      }
      if (type) {
        this.componentObject.true_value = this.fieldObject
      } else {
        this.componentObject.false_value = this.fieldObject
      }
    },
    processArray() {
      const processedData = []
      const idToIndexMap = {}
      this.APIprocessmodules.forEach((item, index) => {
        const newItem = { ...item }
        if (newItem.depends_on === 0) {
          newItem.depends_on = null
        } else if (idToIndexMap[newItem.depends_on] !== undefined) {
          newItem.depends_on = idToIndexMap[newItem.depends_on]
        }

        idToIndexMap[newItem.id] = index
        processedData.push(newItem)
      })

      return processedData
    },
    async getPreviousModules() {
      const processID = this.$route.params.id
      await axios.get(`/process/get-previous-modules/${Number(processID)}`).then(response => {
        if (response.status === 200) {
          const previousModules = response.data.data.map((e, i) => ({ ...e, value: i }))
          this.prevModuleOptions.push(...previousModules)
          sharedState.prevModuleOptions = this.prevModuleOptions
        }
      }).catch(error => console.log(error))
    },
    async getTemplateId() {
      await axios.get('/settings/get-default-action-template?action_id=9').then(settings => {
        if (settings.status) {
          this.paymentEmailTemplate = settings.data.data.template_id
          sharedState.paymentEmailTemplate = this.paymentEmailTemplate
        }
      })
    },
  },
}
</script>

<style lang="scss">
.process-row{
  border-top: 1px solid #e4f2f1;
  border-radius: 10px;
  box-shadow: rgb(33 146 137 / 40%) 0px 6px 15px -7px;
  padding-top: 10px;
  padding-bottom: 10px;
  margin-bottom: 20px;
}

.process-title{
  margin-top: 6px;
}

.awaitlist {
  border-radius: 10px;
}

.form-row.form-group.process-group {
  margin-bottom: 0px;
}

.form-row.form-group.process-group label{
  padding-bottom: 0px;
}

.group-col {
  border-bottom: 1px solid #ececec;
  padding-bottom: 5px;
}

.list-variable-item{
  padding-top: 0px;
}

.row-yes-no {
  margin-top: 5px;
}

.yes-no {
  text-align: center;
  color: #307772;
  font-weight: bolder;
}

.split-div .list-group-item.yes-no{
  background-color: #badcdc;
}

.yes-no:hover {
  text-align: center;
  color: #307772;
  font-weight: bolder;
}

.column-no {
  padding-right: 3px;
}

.column-yes {
  padding-left: 3px;
}

.condition-head {
  display: inline-block;
}

.condition-head-left {
  margin-top: 10px;
}

.condition-head-right {
  float: right;
}

.option-btn .btn.btn-outline-primary:first-child {
  padding: 10px 40px;
}

.list-group-item.main-items {
  text-align: center;
}

.condition-heading-title h4 {
  font-weight: 600;
  font-size: 1.1rem;
  color: inherit;
}

.collapse-icon.collapse-default .card .card-header {
  background-color: #f7f7f7;
}

.nested-condition-module {
  border: 1px solid #e4f2f1;
}

.nested-module {
  margin-bottom: 5px !important;
}

.expand-btn {
  width: 100%;
  margin-top: 10px;
}

.expand-feather {
  top: 0px !important;
}
.main-cols{margin-bottom: 4rem;}
.main-cols:before{
  position: absolute;
  content: '';
  left: 50%;
  transform: translateX(-50%);
  top: 100%;
  width: 40px;
  height: 40px;
  background: url('~@/assets/images/icons/down-arrow-1.png') no-repeat 50% 50% / 30px;
  margin: 0.6rem 0 0;
}
.main-cols .alert{margin-bottom: 0;}
.main-cols:last-child{margin-bottom: 0;}
.main-cols:last-child:before{display: none;}
.moduleFields {
  width: 50%;
}

.scroll-div {
  overflow-y: scroll;
  /* Ensure the inner div doesn't exceed the container */
  max-height: 350px;
  padding-right: 10px;
}

.scroll-div::-webkit-scrollbar {
    width: 12px;
}

.scroll-div::-webkit-scrollbar-track {
    -webkit-box-shadow: inset 0 0 6px rgba(0,0,0,0.3);
    border-radius: 10px;
}

.scroll-div::-webkit-scrollbar-thumb {
    border-radius: 10px;
    -webkit-box-shadow: inset 0 0 6px rgba(0,0,0,0.5);
}
.title-error-class {
  color: red;
}
</style>
